import cx from "classnames";
import { useTranslation } from "react-i18next";

type Size = "tiny" | "small" | "medium" | "large";

type Props = {
  className?: string;
  size?: Size;
  center?: boolean;
  dataTestId?: string;
  label?: string;
};

export const Spinner = ({
  className,
  size = "tiny",
  center,
  dataTestId,
  label = "common.loading",
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      aria-atomic="true"
      role="alert"
      aria-live="polite"
      data-testid={dataTestId}
    >
      <div className="sr-only">{t(label)}</div>
      <div
        className={cx(
          "min-h-[1rem] min-w-[1rem] animate-spin rounded-full border-2 border-solid border-t-blue-500 border-blue-200",
          {
            "m-auto": center,
            "h-4 w-4 border-2": size === "tiny",
            "h-6 w-6 border-2": size === "small",
            "h-8 w-8 border-4": size === "medium",
            "h-10 w-10 border-4": size === "large",
          },
          className
        )}
      ></div>
    </div>
  );
};
